import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const pieces = [
  { type: "q", label: "Queen", icon: "♛" },
  { type: "r", label: "Rook", icon: "♜" },
  { type: "b", label: "Bishop", icon: "♝" },
  { type: "n", label: "Knight", icon: "♞" },
];

export default function PromotionModal({ open, color, onSelect }) {
  return (
    <Dialog open={open} maxWidth="xs" fullWidth>
      <DialogTitle>Pawn Promotion</DialogTitle>
      <DialogContent>
        <Typography gutterBottom>
          Choose a piece to promote your pawn:
        </Typography>
        <Box display="flex" justifyContent="space-around" mt={2}>
          {pieces.map((piece) => (
            <Button
              key={piece.type}
              variant="outlined"
              onClick={() => onSelect(piece.type)}
              sx={{ fontSize: 32, minWidth: 64, minHeight: 64 }}
            >
              {piece.icon}
              <Typography variant="caption" display="block">
                {piece.label}
              </Typography>
            </Button>
          ))}
        </Box>
      </DialogContent>
      <DialogActions>
        {/* No cancel button: promotion is mandatory */}
      </DialogActions>
    </Dialog>
  );
}
